import { combineReducers } from 'redux';
import _ from 'lodash';
import axios from 'axios';
import isEmpty from 'lodash/isEmpty';

import * as Urls from 'src/constants/EndpointUrls';
import { redirectTo, concatParamsToUrl, serializeHttpGetParams } from 'src/utils/Http';
import { setGlobalErrors, setGlobalSuccesses } from 'src/reducers/global';
import { getList, setList } from 'src/reducers/common/listReducer';
import { listReducer, itemReducer } from '../common';
import createNamedWrapperReducer from '../createNamedWrapperReducer';

export const REDUCER_NAME = 'clientCsvFormats';

export const createCsvFormat = data => async dispatch => {
  try {
    if (isEmpty(data.clientCsvFormatFields)) {
      dispatch(setGlobalErrors('項目を1個以上選択してください。'));
    } else {
      await axios.post(Urls.CLIENT_CSV_FORMAT_CREATE, data);
      dispatch(setGlobalSuccesses('フォーマットを作成しました。'));

      const redirectUrl = data.goBackPath || Urls.CLIENT_CSV_FORMATS_LIST;
      redirectTo(redirectUrl);
    }
  } catch (e) {
    dispatch(setGlobalErrors(e.response.data.errors.messages));
  }
};

export const editCsvFormat = data => async dispatch => {
  try {
    if (isEmpty(data.clientCsvFormatFields)) {
      dispatch(setGlobalErrors('項目を1個以上選択してください。'));
    } else {
      const editUrl = concatParamsToUrl(Urls.CLIENT_CSV_FORMAT_UPDATE, { id: data.clientCsvFormat.id });
      await axios.put(editUrl, data);
      dispatch(setGlobalSuccesses('フォーマットを編集しました。'));

      const redirectUrl = data.goBackPath || Urls.CLIENT_CSV_FORMATS_LIST;
      redirectTo(redirectUrl);
    }
  } catch (e) {
    dispatch(setGlobalErrors(e.response.data.errors.messages));
  }
};

export const copyCsvFormat = csvFormatId => async dispatch => {
  try {
    const copyUrl = concatParamsToUrl(Urls.CLIENT_CSV_FORMAT_COPY, { id: csvFormatId });
    const resp = await axios.put(copyUrl);
    if (resp.data.payload.clientCsvFormat.id) {
      redirectTo(concatParamsToUrl(Urls.CLIENT_CSV_FORMAT_EDIT, { id: resp.data.payload.clientCsvFormat.id }));
    } else {
      dispatch(setGlobalErrors('フォーマットがコピーできません。'));
    }
  } catch (e) {
    dispatch(setGlobalErrors(e.response.data.errors.messages));
  }
};

export const deleteCsvFormat = csvFormatId => async (dispatch, getState) => {
  try {
    await axios.delete(concatParamsToUrl(Urls.CLIENT_CSV_FORMAT_UPDATE, { id: csvFormatId }));
    const csvFormats = getList(REDUCER_NAME, getState());
    const newList = _.filter(csvFormats, item => item.id !== csvFormatId);
    dispatch(setList(REDUCER_NAME, { data: newList }));
    dispatch(setGlobalSuccesses('フォーマットを削除しました。'));
  } catch (e) {
    console.log('e', e);
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(listReducer, REDUCER_NAME),
  item: createNamedWrapperReducer(itemReducer, REDUCER_NAME)
});
